<template>
  <transition name="fade">
    <div v-show="canBeShown">
      <contest-menu :visible="isVisible" @hide="closeMenu"/>
      <menu-button :type="menuButtonType" @click="toggleMenu"/>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import ContestMenu from '@/containers/ContestMenu/ContestMenu'
import MenuButton from '@/containers/ContestMenu/MenuButton'

export default {
  components: {
    ContestMenu,
    MenuButton
  },
  data () {
    return {
      isVisible: false
    }
  },
  computed: {
    ...mapState({
      isPlacePickerActive: state => state.picker.isActive
    }),
    menuButtonType () {
      return this.isVisible ? 'open' : 'close'
    },
    canBeShown () {
      return !this.isPlacePickerActive && /^contest.*$/.test(this.$route.name)
    }
  },
  watch: {
    canBeShown () {
      if (this.isPlacePickerActive) {
        this.isVisible = false
      }
    }
  },
  methods: {
    closeMenu () {
      this.isVisible = false
    },
    toggleMenu () {
      this.isVisible = !this.isVisible
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/ContestMenu/ContestMenuContainer.vue